import React, { useEffect, useState } from "react";
import DropdownFluent from "../controls/dropdown/DropdownFluent";
import DateField from "../controls/dateField/DateField";
import { formatDateRange } from "./cardFormat";
import { CUSTOM_PERIOD, PERIOD_PRESETS } from "./periods";
import { useInsightsPeriod } from "./periodStore";
import styles from "./resourceInsights.module.scss";

const OPTIONS = [...PERIOD_PRESETS.map((preset) => ({ name: preset.label, value: preset.value })), { name: "Custom range", value: CUSTOM_PERIOD }];

/**
 * The control of the period Resource Insights is about, for the places of the application that have no period of
 * their own: a usual period from a list, or a range of dates typed in or picked. It drives the one period shared by
 * all of those places, and is not used in the planner, whose own period Resource Insights follows there.
 */
export default function PeriodPicker() {
  const { preset, range, setPreset, setCustom } = useInsightsPeriod();
  const [draft, setDraft] = useState(range);

  // The dates being typed start from the period in use and follow it when it changes by other means.
  useEffect(() => setDraft(range), [range]);

  const isCustom = preset === CUSTOM_PERIOD;
  const label = isCustom ? "Custom range" : PERIOD_PRESETS.find((option) => option.value === preset)?.label;

  // A date only becomes the period once both are whole dates in the right order.
  const changeDate = (key) => (value) => {
    const next = { ...draft, [key]: value };
    setDraft(next);
    if (next.startDate && next.endDate && next.startDate <= next.endDate) setCustom(next);
  };

  return (
    <div className={styles.periodControl}>
      <div className={styles.periodBar}>
        <span className={styles.periodLabel}>Period</span>
        <DropdownFluent key={preset} options={OPTIONS} defaultVal={label} selectedOptions={[preset]} showLabel={false} placeholder="Choose a period" StyleClass={styles.periodSelect} onChange={setPreset} />
        <span className={styles.periodRange}>{formatDateRange(range.startDate, range.endDate)}</span>
      </div>

      {isCustom && (
        <div className={styles.periodDates}>
          <label>
            From
            <DateField tooltip="From" className={styles.periodDateField} value={draft.startDate} maxDate={draft.endDate} onChange={changeDate("startDate")} />
          </label>
          <label>
            To
            <DateField tooltip="To" className={styles.periodDateField} value={draft.endDate} minDate={draft.startDate} onChange={changeDate("endDate")} />
          </label>
        </div>
      )}
    </div>
  );
}
